import { useState } from 'react';

export const useRightComponentHoverTrigger = (isNeedHoverEffect: boolean) => {
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);

  const rightComponentHoverShow = (index: number) => {
    if (isNeedHoverEffect) {
      setHoveredRow(index);
    }
  };

  const rightComponentHoverHide = () => {
    if (isNeedHoverEffect) {
      setHoveredRow(null);
    }
  };

  return { hoveredRow, rightComponentHoverShow, rightComponentHoverHide };
};
